export type Actions = { type: 'SET_SHOW_HINT'; payload: { showHint: boolean } };

export type UseHintState = {
  showHint: boolean;
};

export type UseHintDispatch = {
  setShowHint: () => void;
};

export type UseHint = [UseHintState, UseHintDispatch];

export const HINT_DURATION = 3000;
